import { render, staticRenderFns } from "./Covers.vue?vue&type=template&id=434165b6"
import script from "./Covers.vue?vue&type=script&lang=js"
export * from "./Covers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports